<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 條件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item label="用戶暱稱" prop="userName">
                <a-input v-model="queryParam.userName" placeholder="請輸入用戶暱稱" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="手機號" prop="mobile">
                <a-input v-model="queryParam.mobile" placeholder="請輸入手機號" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="!advanced && 8 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查詢</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 增加修改 -->
      <create-form
        ref="createForm"
        @ok="getList"
      />
      <!-- 增加詳情 -->
      <detail-form
        ref="detailForm"
        @ok="getList"
      />
      <!-- 數據展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :pagination="false"
        :bordered="tableBordered"
      >
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="operation" slot-scope="text, record">
           <a @click="$refs.detailForm.handleUpdate(record, undefined)">
            綁定信息
          </a>
          <a-divider type="vertical"/>
          <a v-if="record.status == 0" @click="$refs.createForm.handleUpdate(record, undefined)">
            審核
          </a>
        </span>
      </a-table>
      <!-- 分頁 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => `共 ${total} 條`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageUserWithdraw,delUserWithdraw } from '@/api/platform/userWithdraw'
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'
import DetailForm from './modules/DetailForm'

export default {
  name: 'UserWithdraw',
  components: {
    CreateForm,
    DetailForm
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      // 高級搜索 展開/關閉
      advanced: false,
      // 非單個禁用
      single: true,
      // 非多個禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查詢參數
      queryParam: {
        userId: null,
        money: null,
        platformMoney: null,
        realMoney: null,
        serviceChargeNum: null,
        status: null,
        withdrawType: null,
        failureReason: null,
        auditOpinion: null,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: '用戶暱稱',
          dataIndex: 'userName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '用戶手機號',
          dataIndex: 'mobile',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '提現金額',
          dataIndex: 'money',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '平臺抽取金額',
          dataIndex: 'platformMoney',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '實際需要轉賬金額',
          dataIndex: 'realMoney',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '提現手續費',
          dataIndex: 'serviceChargeNum',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '提現方式',
          dataIndex: 'withdrawType',
          ellipsis: true,
          align: 'center',
          customRender: function (value) {
            if (value == 1){
              return "支付寶"
            }
            if (value == 2){
              return "微信"
            }
            if (value == 3){
              return "銀行卡"
            }
          }
        },
        {
          title: '審核狀態',
          dataIndex: 'status',
          ellipsis: true,
          align: 'center',
          customRender: function (value) {
            if (value == 0){
              return "未審核"
            }
            if (value == 1){
              return "已通過"
            }
            if (value == 2){
              return "已拒絕"
            }
          }
        },
        {
          title: '失敗原因',
          dataIndex: 'failureReason',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '插入時間',
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: '操作',
          dataIndex: 'operation',
          width: '18%',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    }
  },
  filters: {
  },
  created () {
    this.getList()
  },
  computed: {
  },
  watch: {
  },
  methods: {
    /** 查詢用戶提現記錄列表 */
    getList () {
      this.loading = true
     pageUserWithdraw(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },

    /** 搜索按鈕操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按鈕操作 */
    resetQuery () {
      this.queryParam = {
        userId: undefined,
        money: undefined,
        platformMoney: undefined,
        realMoney: undefined,
        serviceChargeNum: undefined,
        status: undefined,
        withdrawType: undefined,
        failureReason: undefined,
        auditOpinion: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 刪除按鈕操作 */
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      if(row.id){
        this.ids.push(row.id)
      }
      this.$confirm({
        title: '確認刪除所選中數據?',
        content: '當前選中編號為' + ids + '的數據',
        onOk () {
          let data = []
          that.ids.map(id => data.push({"id":id}))
          return delUserWithdraw(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                '刪除成功',
                3
              )
          })
        },
        onCancel () {
          //取消清空刪除ids列表
          that.ids = []
        }
      })
    },
    /** 導出按鈕操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: '是否確認導出?',
        content: '此操作將導出當前條件下所有數據而非選中數據',
        onOk () {
          that.download('platform/user-withdraw/export', {
            ...that.queryParam
          }, `用戶提現記錄_${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
    }
  }
}
</script>
